import Carousel from './Carousel';

export type {
  CarouselProps,
  ProductCarouselItem,
  BaseCarouselItemType,
  CarouselItems,
  CarouselButtonType,
  CarouselItemVariant,
  ReviewCarouselItem,
} from './interface';

export default Carousel;
